// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

window.process = { env: { NODE_ENV: "development" } };

import "./initIcons";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./i18n";
import App from "./App";
import "./index.scss";
import { authService } from "./services/AuthService";

async function bootstrap() {
  await authService.init();

  ReactDOM.render(
    <Suspense fallback={<>Loading...</>}>
      <App />
    </Suspense>,
    document.getElementById("root")
  );
}

bootstrap();
